import React, { Component } from 'react';

class WebsiteSelector extends Component {
    render() {
        if (this.props.websites.length !== 0) {
            return (
                <div className="header__flags mobile">
                    {this.props.websites.map((data, index) => (
                        <a href={"//" + data.url} title={data.title} key={index} className="header__flags--link">
                            <img src={data.imageToUrl} />
                        </a>
                    ))}
                </div>
            );
        } else {
            return null;
        }
    }
}

export default WebsiteSelector;